import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks";

import Header from "./Header";
import Sidebar from "./Sidebar/Sidebar";
import VerifyEmailModal from "./Popup/VerifyEmailModal";

import "../styles/global.css";

export default function Layout() {
  const user = useAppSelector((state) => state.user);
  const { pathname } = useLocation();
  if (user.id === 0) {
    localStorage.setItem(
      "redirectAfterLogin",
      location.pathname + location.search,
    );
    return <Navigate to="/login" replace />;
  } else
  return (
    <>
      <Header />
      <main>
        <Sidebar />
        <Outlet />
      </main>
      {user.verified === false && pathname !== "/settings/account" && <VerifyEmailModal />}
    </>
  );
}
